import { subscribeNote } from "@/mocks/guaData";

export default function SubscribeBar() {
  return (
    <section id="subscribe" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
        <div className="relative overflow-hidden rounded-xl border border-accent-200/70 bg-gradient-to-r from-primary-50 via-accent-50 to-background-100 px-6 py-10 text-center md:px-10 md:py-12">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(210,120,60,0.10),transparent_45%)]" />
          <div className="relative mx-auto max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-notification-3-fill" />
              蹲瓜提醒
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              收藏「吃瓜m」，每天新瓜不迷路
            </h2>
            <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
              {subscribeNote}
            </p>
            {/* 静态订阅条：仅演示交互，不做真实提交 */}
            <div className="mx-auto mt-6 flex max-w-md flex-col gap-2 sm:flex-row">
              <input
                type="email"
                name="email"
                aria-label="你的邮箱"
                placeholder="留下邮箱，早八点喊你来吃瓜"
                className="w-full flex-1 rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-300 focus:ring-2 focus:ring-primary-200/50"
              />
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
              >
                订阅最新瓜单
              </button>
            </div>
            <p className="mt-3 text-xs text-foreground-400">演示页面 · 仅展示订阅体验，不收集信息</p>
          </div>
        </div>
      </div>
    </section>
  );
}